import SafeIcon from '../common/SafeIcon';

const footerLinks = [['Rooms', '/#rooms'], ['Experiences', '/#experience'], ['Gallery', '/#gallery'], ['Location', '/#location']];

function SiteFooter({ BrandMark }) {
  return (
    <footer className="site-footer" id="contact">
      <div className="site-footer__top">
        <div><BrandMark light /><p>A softer kind of safari escape,<br />in the heart of Sri Lanka’s south.</p></div>
        <div className="site-footer__links"><span>EXPLORE</span>{footerLinks.map(([label, href]) => <a href={href} key={label}>{label}</a>)}</div>
        <div className="site-footer__contact"><span>COME SAY HELLO</span><a href="mailto:info@leopardblissyala.com">info@leopardblissyala.com</a><a href="tel:+94743630000">+94 743 630 000</a><p>Tissamaharama, Sri Lanka</p></div>
        <div className="site-footer__social"><span>FOLLOW ALONG</span><div><a href="https://www.instagram.com/leopardblissyala/" target="_blank" rel="noreferrer" aria-label="Instagram"><SafeIcon name="Instagram" /></a><a href="https://www.facebook.com/leopardblissyala" target="_blank" rel="noreferrer" aria-label="Facebook"><SafeIcon name="Facebook" /></a></div></div>
      </div>
      <div className="site-footer__bottom"><span>© {new Date().getFullYear()} Leopard Bliss Yala</span><span>MADE FOR THE MOMENTS IN BETWEEN</span><a href="/#home">Back to top ↑</a></div>
    </footer>
  );
}

export default SiteFooter;